import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import {
    CONTEXT_API_CEAF_RECUPERER_DERNIERE_EDITEE,
    CONTEXT_CEAF_CREER,
    CONTEXT_CEAF_GENERATION_PDF,
    CONTEXT_EDITER_CEAF,
    CONTEXT_API_CEAF_VISUALISER,
} from '../../constants/apiUrls.constants';

const ceaf = combineReducers({
    editer: APIReducer.bind(null, CONTEXT_EDITER_CEAF),
    creer: APIReducer.bind(null, CONTEXT_CEAF_CREER),
    recuperDerniereEditee: APIReducer.bind(null, CONTEXT_API_CEAF_RECUPERER_DERNIERE_EDITEE),
    visualiser: APIReducer.bind(null, CONTEXT_API_CEAF_VISUALISER),
    fichierPdfBase64: APIReducer.bind(null, CONTEXT_CEAF_GENERATION_PDF),
});

export default ceaf;
